import cn from '@/lib/clsxm';

import Container from '@/components/@base/container';
import { CONTAINER_TAG_TYPE } from '@/components/@base/container/type';
import XImage from '@/components/@base/x-image';
import ProgressBar from '@/components/app/product/components/@shared/progress-bar';
import Timer from '@/components/app/product/components/discount-countdown/timer';
import Props from '@/components/app/product/components/discount-countdown/type';
import IconTextCombo from '@/components/shared/components/icon-text-combo';

import imagesList from '@/constant/images-list';
import { pageLevelLocalization } from '@/constant/localization';

const { product: productLocalization } = pageLevelLocalization;

export default function DiscountCountdown({
  remainingAmount = 0,
  totalAmount = 1,
  saleEndedAt = 0,
  saleStartedAt = 0,
  className,
}: Props) {
  let remainingPercent = 0;
  let deadline = saleEndedAt;
  if (remainingAmount > 0) {
    remainingPercent = (remainingAmount / totalAmount) * 100;
  } else {
    if (deadline <= Date.now()) {
      deadline = Date.now();
    } else {
      remainingPercent = (100 * (deadline - Date.now())) / (deadline - saleStartedAt);
    }
  }

  return (
    <Container className={cn('mx-auto px-4 md:px-0', className)}>
      <Container center className='justify-between'>
        <IconTextCombo
          Icon={
            <XImage
              src={imagesList.icons.discountIcon}
              alt={productLocalization.specialDiscount}
              width={20}
              height={20}
            />
          }
          title={productLocalization.specialDiscount}
          textClassName='text-[#EB8800] text-sm font-bold'
          wrapperClassName='w-fit'
        />
        {remainingAmount > 0 ? (
          <Container
            type={CONTAINER_TAG_TYPE.SPAN}
            className='text-sm font-bold text-[#544C45]'
          >
            {productLocalization.remainingAmount(remainingAmount)}
          </Container>
        ) : (
          <Timer deadline={new Date(deadline)} />
        )}
      </Container>
      <ProgressBar progressPercent={remainingPercent} className='my-2' />
    </Container>
  );
}
